<obg-session-timer-container [timerText]="'timer.session.text.ksa'"></obg-session-timer-container>

<div class="local-netherlands-time" *ngIf="time$ | async as time">
	<time test-id="obj-real-time">{{ time }}</time>

	<i class="ico-clock clock-icon"></i>
</div>
